
export type BiometricPlatform = typeof BiometricPlatform[keyof typeof BiometricPlatform];


export const BiometricPlatform = {
  ios: 'ios',
  android: 'android',
} as const;
